<div class="ui-radio" [ngClass]="{'ui-radio--tag': tag}">
  <input
    id="{{id}}"
    type="radio"
    [name]="name"
    [value]="value"
    [required]="required"
    [disabled]="disabled"
    [checked]="checked"
    (change)="onInputChange($event)"
    class="ui-radio__input"
  />
  <label [for]="id" class="ui-radio__label">
    <ng-content></ng-content>
  </label>
</div>
